<template>
    <div>
        <div  class="modal_design">
            <b-modal title="নতুন বিল" no-close-on-backdrop hide-footer size="md" v-model="largeModal" @ok="largeModal = false">
                <form @submit.prevent="billCreate()">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="start_date">Start Month</label>
                                <input v-model="data.start_date" name="start_date" data-vv-as="'Start Month'" v-validate="'required'" type="month" class="form-control" min="2020-01" id="start_date">
                                <p v-show="errors.has('start_date')"  style="color:red">* {{ errors.first('start_date') }}</p>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="end_date">End Month</label>
                                <input v-model="data.end_date" name="end_date" data-vv-as="'End Month'" v-validate="'required'" type="month" min="2020-01" class="form-control" id="end_date">
                                <p v-show="errors.has('end_date')" style="color:red">* {{ errors.first('end_date') }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="start_date">Bill for (Years)</label>
                                <select class="form-control" v-model="data.bill_for">
                                    <option value="">মাস সিলেক্ট করুন</option>
                                    <option v-for="index in 5" :key="index" :value="index">
                                        {{ index }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6">
                            <label for="last_date">Last payment date</label>
                            <input v-model="data.last_date" name="last_date"  data-vv-as="'Last date'" v-validate="'required'" type="date" class="form-control" id="last_date">
                            <p v-show="errors.has('last_date')"  style="color:red">* {{ errors.first('last_date') }}</p>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary float-right">Submit</button>
                    </form>
            </b-modal>
        </div>
        <Loader v-if="loading"></Loader>
    </div>
</template>

<script>
    import Loader from '../common/Loader'
    import axios from 'axios'
    import moment from 'moment'
    export default {
        name: "BillCreate",
        components:{
            Loader
        },
        data(){
            return{
                loading:false,
                largeModal:false,
                cur_date : new Date(),
                data:{
                    end_date:new Date().getFullYear()+'-'+this.str_pad(moment().month(new Date().getMonth()).format("M")),
                    start_date:moment(new Date().getFullYear()+'-'+this.str_pad(moment().month(new Date().getMonth()).format("M"))).subtract(2, 'months').format('YYYY-MM'),
                    last_date:'',
                    invoice_type:'',
                    skip:0,
                    bill_for:1
                },
                date:{
                    start_year:null,
                    end_year:null,
                    start_month:null,
                    end_month:null,
                }
            }
        },

        methods:{
            billCreate()
            {
                this.data.invoice_type = 'lease-billing'

                // this.largeModal=false
                this.$validator.validateAll().then( result =>{
                    if(result){

                        var full_start_date = this.data.start_date+'-01'
                        var full_end_date = this.data.end_date+'-01'
                        var bill = this.data.bill_for

                        var last_start_date = this.date.start_year+'-'+this.date.start_month+'-01'
                        var last_end_date = this.date.end_year+'-'+this.date.end_month+'-01'

                        var MonthsAgo = moment(full_end_date).subtract((bill*12)-1, 'months').format('YYYY-MM-DD');
                        var first_date = moment(full_start_date).format('YYYY-MM-DD');
                        var second_date = moment(last_end_date).format('YYYY-MM-DD');
                        //alert(MonthsAgo)

                        //second_date!=last_end_date ||
                        if(moment(first_date).isSameOrBefore(last_end_date)){
                            alert('Already Bill Exists !!!')
                        }else{
                            if(first_date==MonthsAgo){
                                this.loading = false
                                this.largeModal = false
                                this.billConfirmation()
                            } else {
                                alert('Year Range is not correct !!!')
                            }
                        }

                    }

                })
            },
            billConfirmation(){
                var self = this
                this.$iziToast.question({
                    timeout: 100000,
                    close: false,
                    overlay: true,
                    displayMode: 'once',
                    id: 'question',
                    zindex: 99999,
                    title: 'Hey',
                    message: 'Are you sure To Bill Create?',
                    position: 'center',
                    buttons: [
                        ['<button><b>YES</b></button>', function (instance, toast) {
                            self.loading=true
                            self.createBillStart()
                            .then(response=>{
                                self.$iziToast.success({position:'topRight',title:'Ok',message:"Bill Created Successfully"})
                            })
                            .catch(error=>{
                                self.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
                            });
                            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');

                        }, true],
                        ['<button>NO</button>', function (instance, toast) {

                            instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');

                        }],
                    ]
                });

            },
            str_pad(n) {
                return String("00" + n).slice(-2);
            },
            openModal(date){
                //alert(date)
                this.date = date
                this.data.end_date=new Date().getFullYear()+'-12';
                this.data.start_date=new Date().getFullYear()+'-01';
                this.data.bill_for= 1;
                this.data.last_date='';
                this.largeModal = true;
            },
            async createBillStart(){
                //alert('ddd')
                await this.createBill1()
                await this.createBill2()
                await this.createBill3()
                await this.createBill4()
                await this.createBill5()
                await this.createBill6()
                await this.createBill7()
                await this.createBill8()
                await this.createBill9()
                await this.createBill10()
                await this.createBill11()
                await this.createBill12()
                await this.createBill13()
                await this.createBill14()
                await this.createBill15()
                await this.createBill16()
                await this.createBill17()
                await this.createBill18()
                await this.createBill19()
                await this.createBill20()

            },
            async createBill1(){
                this.data.skip = 0;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill2(){
                this.data.skip = 1000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill3(){
                this.data.skip = 2000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill4(){
                this.data.skip = 3000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill4(){
                this.data.skip = 3000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill5(){
                this.data.skip = 4000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill6(){
                this.data.skip = 5000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill7(){
                this.data.skip = 6000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill8(){
                this.data.skip = 7000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill9(){
                this.data.skip = 8000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill10(){
                this.data.skip = 9000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill11(){
                this.data.skip = 10000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill12(){
                this.data.skip = 11000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill13(){
                this.data.skip = 12000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill14(){
                this.data.skip = 13000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill15(){
                this.data.skip = 14000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill16(){
                this.data.skip = 15000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill17(){
                this.data.skip = 16000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill18(){
                this.data.skip = 17000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill19(){
                this.data.skip = 18000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                })
                .catch(error=>{
                });
            },
            async createBill20(){
                this.data.skip = 19000;
                await axios.post('/api/bill-generate',this.data).then(response=>{
                    this.loading = false
                    this.$parent.getBills();
                    this.largeModal = false
                    this.$swal(
                        'Created',
                        'Bill has been created.',
                        'success'
                    )
                })
                .catch(error=>{
                });
            }
        }
    }
</script>

<style scoped>
    .modal_design{
        width: 300px;
        _height: 100px;
    }
</style>